import { useState } from 'react';
import { Minus, Plus } from 'lucide-react';

export default function NumberInput({ name, value, defaultValue = 0, min, max, required, className, onChange }) {
    const [internalValue, setInternalValue] = useState(defaultValue);
    const currentValue = value !== undefined ? value : internalValue;

    const handleChange = (e) => {
        let val = parseInt(e.target.value, 10);
        if (isNaN(val)) val = min || 0;
        if (max !== undefined && val > max) val = max;
        if (min !== undefined && val < min) val = min;
        setInternalValue(val);
        if (onChange) onChange(val);
    };

    const handleIncrement = () => {
        let val = currentValue + 1;
        if (max !== undefined && val > max) val = max;
        setInternalValue(val);
        if (onChange) onChange(val);
    };

    const handleDecrement = () => {
        let val = currentValue - 1;
        if (min !== undefined && val < min) val = min;
        setInternalValue(val);
        if (onChange) onChange(val);
    };

    return (
        <div className={`flex items-center bg-surface-2 border border-border rounded-lg overflow-hidden ${className}`}>
            <button 
                type="button" 
                onClick={handleDecrement}
                className="p-2 text-muted hover:text-primary hover:bg-surface transition-colors focus:outline-none"
            >
                <Minus className="w-4 h-4" />
            </button>
            <input
                type="number"
                name={name}
                value={currentValue}
                onChange={handleChange}
                required={required}
                className="flex-1 w-full bg-transparent text-center font-semibold text-primary focus:outline-none hide-spinners"
                min={min}
                max={max}
            />
            <button 
                type="button" 
                onClick={handleIncrement}
                className="p-2 text-muted hover:text-primary hover:bg-surface transition-colors focus:outline-none"
            >
                <Plus className="w-4 h-4" />
            </button>
            <style jsx>{`
                .hide-spinners::-webkit-inner-spin-button, 
                .hide-spinners::-webkit-outer-spin-button { 
                    -webkit-appearance: none; 
                    margin: 0; 
                }
                .hide-spinners {
                    -moz-appearance: textfield;
                }
            `}</style>
        </div>
    );
}
